export const ERROR_BAD_INPUT = 'bad_input';
export const ERROR_ACCESS_DENIED = 'access_denied';



// WEBPACK FOOTER //
// ./src/lib/errorTypes.js